export default __webpack_public_path__ + "static/media/error-provider.f5f7c5ef.svg";